'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import ShareInput from '../../decorators/ShareInput';
import UISearchInput from '../../input/UISearchInput';

class UITypeaheadSearch extends PureComponent {
  render() {
    const _this$props = this.props,
          {
      'aria-controls': ariaControls,
      className,
      Input,
      style
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["aria-controls", "className", "Input", "style"]);

    return /*#__PURE__*/_jsx("div", {
      className: classNames('private-search-control__wrapper', className),
      style: style,
      children: /*#__PURE__*/_jsx(Input, Object.assign({
        "aria-autocomplete": "list",
        "aria-controls": ariaControls
      }, rest))
    });
  }

}

UITypeaheadSearch.propTypes = {
  'aria-controls': PropTypes.string,
  Input: PropTypes.elementType.isRequired
};
UITypeaheadSearch.defaultProps = {
  autoComplete: 'off',
  Input: UISearchInput
};
UITypeaheadSearch.displayName = 'UITypeaheadSearch';
export default ShareInput(UITypeaheadSearch);